<template>
    <div class="form-group">
        <label v-if="label">{{ label }}</label>
        <div class="input-group">
            <flat-pickr
                v-model="localValue"
                :placeholder="$t('Select date')"
                :config="calendarOptionsComputed"
                class="form-control form-control-appended"
                ref="datePickerWrap"
            ></flat-pickr>
            <div class="input-group-append" data-toggle>
                <div class="input-group-text">
                    <span class="fe fe-calendar"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';

import { Russian } from "flatpickr/dist/l10n/ru.js"
import { Turkish } from "flatpickr/dist/l10n/tr.js"




import 'flatpickr/dist/flatpickr.css';

export default {
    props: ['value', 'calendarOptions', 'label', 'refTo'],
    components: {
        flatPickr,
    },
    data() {
        return {
            localValue: null,
            calendarDefaultOptions: {
                wrap: true,
                inline: false,
                static: false,
                allowInput: true,
                altFormat: 'l F j, Y',
                altInput: true,
                dateFormat: 'Y-m-d',
                locale: {
                    firstDayOfWeek: 1
                }
                // minDate: new Date(),
            },
        }
    },
    created() {

        let locales = {
            ru: Russian,
            tr: Turkish,
        }

        flatpickr.localize(locales[this.$locale]);

        if (this.value) {
            this.localValue = this.value;
        }
        else {
            this.localValue = this.$moment().format('YYYY-MM-DD');
        }
    },
    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newValue) {
            this.$emit('input', newValue);
        }
    },
    methods: {

    },
    computed: {
        calendarOptionsComputed() {
            return Object.assign(this.calendarDefaultOptions, this.calendarOptions);
        }
    }

}
</script>
